import { ReactElement, ReactNode } from 'react'
import { AgentResponse, DevicesResponse } from '../../../../NonReact/Types/Types'
import { SelectRangeItemState } from './Constants'
import { TelSysTypes } from '../../../../NonReact/constants/TelephonyServerTypes'

export type TelSys = {
    Description: string
    TelSysID: number
    TelSysTypeID: number
    PartitionLicences?: string[]
}

export type SelectOptionValues = string | number

export type SelectOption<T extends SelectOptionValues> = {
    label: string
    value: T
    renderOptionElement?: ReactElement
    defaultSelected?: boolean
    className?: string
    IDOnTelSys?: string
    enabled?: boolean
    licences?: string[]
    licencedForRptType?: string
    itemState?: SelectRangeItemState
    telSysType?: TelSysTypes
}

export type EntitySelectOption<
    T extends SelectOptionValues,
    U extends AgentResponse | DevicesResponse | TelSys
> = SelectOption<T> & {
    original?: U
}

export type SelectOptions<T extends SelectOptionValues> = SelectOption<T>[]

export type EntitySelectOptions<
    T extends SelectOptionValues,
    U extends AgentResponse | DevicesResponse | TelSys
> = EntitySelectOption<T, U>

export type BaseSelectProps<T extends SelectOptionValues> = {
    label?: ReactNode
    options: SelectOptions<T>
    disabled?: boolean
    renderSelectedValue?: boolean
}

/**
 * Range select box item type.
 */
export type SelectRangeItem = {
    value: string
    description?: string
    state?: SelectRangeItemState
    renderElement: ReactElement
}

export interface SelectItem {
    value: string
    state?: SelectRangeItemState
    label: string
}

export interface ComboBoxItem<T> {
    value: T
    label: string
}

export interface DeviceSelectItem extends SelectItem {
    index?: number
    type?: string
    original?: DevicesResponse
    additionalDevices?: DeviceSelectItem[]
    isAgent?: boolean
}

export interface AgentSelectItem extends SelectItem {
    original?: AgentResponse
}

export interface TelSysSelectItem extends SelectItem {
    original?: TelSys
}

export type SearchAllItemsResponse = {
    Data: []
}

export type HandleChange = (value: string, oldValue?: string) => void
